import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const Sectors = () => {
  const { t } = useLang();
  return (
    <section
      id="sectors"
      data-testid="sectors-section"
      className="relative bg-[#002B6B] text-white py-24 md:py-36 overflow-hidden grain-overlay"
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-30"
        style={{ background: "radial-gradient(900px 500px at 80% 0%, rgba(111,45,189,0.55), transparent 60%)" }}
      />

      <div className="relative max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-20 items-end">
          <div className="lg:col-span-7">
            <p className="text-[11px] tracking-[0.35em] uppercase text-[#B89DDE] font-semibold mb-6 flex items-center gap-3">
              <span className="inline-block w-10 h-px bg-[#B89DDE]" />
              {t.sectors.overline}
            </p>
            <h2
              data-testid="sectors-title"
              className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] uppercase"
            >
              {t.sectors.title}
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg text-white/75 font-editorial font-light leading-relaxed">
              {t.sectors.lead}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {t.sectors.list.map((s, i) => (
            <motion.div
              key={s}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              data-testid={`sector-${i}`}
              className="group bg-[#002B6B] px-5 py-8 md:px-7 md:py-10 flex items-end min-h-[140px] md:min-h-[180px] transition-colors hover:bg-[#6F2DBD]"
            >
              <div className="flex-1">
                <span className="text-[10px] tracking-[0.3em] uppercase font-bold text-white/55 group-hover:text-white/85">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="font-display text-lg md:text-xl mt-2 leading-tight uppercase">
                  {s}
                </p>
              </div>
              <span className="text-white/40 text-lg group-hover:text-white group-hover:translate-x-1 transition-all">→</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sectors;
